import React from "react";
import Icon from "@ant-design/icons";


const StaffSameDeviceSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M26.87,9.85h-6.12c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h6.12c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z" />
        <path d="M43.6,41.58l-8.44-8.44V9.95c0-3.22-2.62-5.85-5.85-5.85h-10.99c-3.22,0-5.85,2.62-5.85,5.85v.5l-6.16-6.16c-.49-.49-1.28-.49-1.77,0s-.49,1.28,0,1.77l7.92,7.92v24.71c0,3.22,2.62,5.85,5.85,5.85h10.99c3.22,0,5.85-2.62,5.85-5.85v-2.02l6.68,6.68c.24.24.56.37.88.37s.64-.12.88-.37c.49-.49.49-1.28,0-1.77ZM14.97,9.95c0-1.85,1.5-3.35,3.35-3.35h10.99c1.85,0,3.35,1.5,3.35,3.35v20.69L14.97,12.95v-3ZM32.65,38.7c0,1.85-1.5,3.35-3.35,3.35h-10.99c-1.85,0-3.35-1.5-3.35-3.35v-22.21l17.69,17.69v4.52Z" />
    </svg>
);

const StaffSameDeviceIcon = (props) => <Icon { ...props } component={ StaffSameDeviceSvg } />;

export default StaffSameDeviceIcon;
